import { useEffect, useState } from 'react'

/**
 * Stub hook for SignalR connection management.
 * TODO: Implement real SignalR connection logic when ready.
 */
const useSignalR = (_isLogin: any) => {
  const [connection, _setConnection] = useState<any>(null)
  const [connectionId, _setConnectionId] = useState<string>('')

  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional dependency list
  useEffect(() => {
    // TODO: Initialize SignalR connection here
  }, [_isLogin])

  return { connection, connectionId }
}

export default useSignalR
